import { useState } from "react";
import VerticalBarChart from "../../../components/VerticalBarChart";
import { chartColors } from "../../../utils/constants";
import styles from "../styles/page.module.css";
import { Modal, Table } from "antd";

const ChartCategory = ({ questions, title }) => {
  const [optionSelected, setOptionSelected] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);


  const getItemWidth = (question) => {
    if (![1, 2].includes(question.id_type_question)) {
      return question.questionsOptions.length > 3 ? "80%" : "50%";
    }
    return "100%";
  };

  return (
    <div className={styles["statistics-chart-category"]}>
      <h2 className={styles["statistics-chart-category-title"]}>{title}</h2>

      <div className={styles["statistics-chart-list"]}>
        {questions?.map((question) => (
          <div
            key={question.id_question}
            className={styles["statistics-chart-item"]}
            style={{
              width: getItemWidth(question),
            }}
          >
            <h2>{question.question_description}</h2>
            {![1, 2].includes(question.id_type_question) ? (
              <VerticalBarChart
                handleClick={(indexOption) => {
                  setOptionSelected(question.questionsOptions[indexOption]);
                  setIsModalOpen(true);
                }}
                data={{
                  labels: question.questionsOptions.map(
                    (option) => option.option
                  ),
                  datasets: [
                    {
                      data: question.questionsOptions.map(
                        (option) => option.percentData
                      ),
                      backgroundColor: question.questionsOptions.map(
                        (_, index) => chartColors[index % chartColors.length]
                      ),
                      // @ts-expect-error meta
                      metaData: question.questionsOptions.map((option) => ({
                        countData: option.countData,
                        percent: option.percentData,
                        comments: option.comments,
                      })),
                    },
                  ],
                }}
              />
            ) : (
              <div className={styles["questions-text-list"]}>
                {question?.responseData?.map((response, index) => (
                  <div key={`${response.text} ${index}`}>
                    <div className={styles["questions-text-item"]}>
                      {response.text}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
      <Modal
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        centered
        title={`Usuarios que respondieron: "${optionSelected.option}"`}
        visible={isModalOpen}
        width={700}
      >
        <Table
          columns={[
            {
              dataIndex: "customer",
              title: "Cliente",
            },
            {
              dataIndex: "comment",
              title: "Comentario",
              render: (value) => value || "N/A",
            },
          ]}
          dataSource={optionSelected.comments}
          pagination={{
            hideOnSinglePage: true,
            pageSize: 30
          }}
        />
      </Modal>
    </div>
  );
};

export default ChartCategory;
